// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Pie } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
// import { API_URL } from "../../config";
// import LoadingSpinner from "../../components/LoadingSpinner";
// import { useParams } from "react-router-dom";

// // Register Chart.js components
// ChartJS.register(ArcElement, Tooltip, Legend, Title);

// // Default colors as fallback
// const defaultColors = {
//   Email: "#007BFF",
//   PushNotification: "#FF6B6B",
//   WhatsApp: "#22C55E",
//   SMS: "#F59E0B",
// };

// // Chart options
// const chartOptions = {
//   responsive: true,
//   plugins: {
//     legend: {
//       position: "bottom",
//       labels: {
//         font: {
//           size: 12,
//           family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//         },
//         color: "#3D5A80",
//         padding: 10,
//         usePointStyle: true,
//         pointStyle: "circle",
//       },
//     },
//     title: {
//       display: true,
//       font: {
//         size: 16,
//         weight: "bold",
//         family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       },
//       color: "#293241",
//       padding: 10,
//     },
//     tooltip: {
//       backgroundColor: "rgba(255, 255, 255, 0.95)",
//       titleColor: "#293241",
//       bodyColor: "#3D5A80",
//       borderColor: "#E94F37",
//       borderWidth: 1,
//       cornerRadius: 6,
//       titleFont: { size: 12, weight: "bold" },
//       bodyFont: { size: 11 },
//       padding: 8,
//     },
//   },
//   animation: {
//     animateScale: true,
//     animateRotate: true,
//   },
//   maintainAspectRatio: false,
// };

// // Helper function to create chart config using API colors
// const createChartConfig = (channel, data) => {
//   if (!data || !Array.isArray(data) || data.length === 0) {
//     return {
//       labels: ['No Data'],
//       datasets: [
//         {
//           label: `${channel} Distribution`,
//           data: [1],
//           backgroundColor: ['#CCCCCC'],
//           borderColor: ["#fff"],
//           borderWidth: 2,
//           hoverBorderColor: "#000",
//           hoverBorderWidth: 2,
//         },
//       ],
//     };
//   }

//   return {
//     labels: data.map((item) => item.label),
//     datasets: [
//       {
//         label: `${channel} Distribution`,
//         data: data.map((item) => item.value),
//         backgroundColor: data.map((item) => item.color || defaultColors[channel] || '#CCCCCC'),
//         borderColor: ["#fff"],
//         borderWidth: 2,
//         hoverBorderColor: "#000",
//         hoverBorderWidth: 2,
//       },
//     ],
//   };
// };

// const CampingDetails = () => {
//   const { cid } = useParams(); // Get cid from URL
//   const [chartData, setChartData] = useState(null);
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [tableLoading, setTableLoading] = useState(false);
//   const [channel, setChannel] = useState("Email"); // Default channel
//   const [error, setError] = useState(null);

//   // Fetch chart data
//   useEffect(() => {
//     const fetchChartData = async () => {
//       if (!cid) {
//         setError("No Campaign ID provided");
//         setLoading(false);
//         return;
//       }

//       try {
//         setLoading(true);
//         setError(null);
//         const token = localStorage.getItem("authToken");

//         if (!token) {
//           setError("Authentication token not found");
//           setLoading(false);
//           return;
//         }

//         console.log("Fetching chart data for CID:", cid);

//         const response = await axios.get(
//           `${API_URL}settings/templateBulkCampaign/chart?cid=${cid}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               accept: "*/*",
//             },
//             timeout: 30000, // 30 second timeout
//           }
//         );

//         console.log("API Response:", response.data);

//         if (response.data && response.data.status && response.data.data) {
//           setChartData(response.data.data);
//         } else {
//           console.error("Invalid API response structure", response.data);
//           setError("Invalid data format received from server");
//         }
//       } catch (error) {
//         console.error("Error fetching chart data:", error);
//         let errorMessage = "Failed to fetch chart data";

//         if (error.response) {
//           // Server responded with error status
//           errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
//         } else if (error.request) {
//           // Request made but no response received
//           errorMessage = "No response from server. Please check your connection.";
//         } else {
//           // Something else happened
//           errorMessage = error.message;
//         }

//         setError(errorMessage);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchChartData();
//   }, [cid]);

//   // Fetch table data based on selected channel
//   const fetchTableData = async (selectedChannel) => {
//     if (!cid) {
//       console.error("No cid available");
//       setTableData([]);
//       return;
//     }

//     setTableLoading(true);
//     try {
//       const token = localStorage.getItem("authToken");

//       if (!token) {
//         console.error("No authentication token");
//         setTableData([]);
//         return;
//       }

//       // Map channel names to API endpoints
//       const channelEndpoints = {
//         Email: "email",
//         SMS: "sms",
//         PushNotification: "push",
//         WhatsApp: "whatsapp"
//       };

//       const endpoint = channelEndpoints[selectedChannel];

//       if (!endpoint) {
//         console.error("Invalid channel selected");
//         setTableData([]);
//         return;
//       }

//       console.log(`Fetching table data for ${selectedChannel} with CID: ${cid}`);

//       const response = await axios.get(
//         `${API_URL}settings/templateBulkCampaign/${endpoint}?cid=${cid}&orderBy=created_on&limit=100&offset=0`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             accept: "*/*",
//           },
//           timeout: 30000,
//         }
//       );

//       console.log(`Table data for ${selectedChannel}:`, response.data);

//       if (response.data && response.data.status && Array.isArray(response.data.data)) {
//         setTableData(response.data.data);
//       } else {
//         console.error("Invalid table data response structure");
//         setTableData([]);
//       }
//     } catch (error) {
//       console.error(`Error fetching ${channel} table data:`, error);
//       setTableData([]);
//     } finally {
//       setTableLoading(false);
//     }
//   };

//   // Fetch table data when channel changes
//   useEffect(() => {
//     if (cid && chartData) { // Only fetch table data if chart data is loaded
//       fetchTableData(channel);
//     }
//   }, [channel, cid, chartData]); // Added chartData as dependency

//   // Handle channel change
//   const handleChannelChange = (newChannel) => {
//     setChannel(newChannel);
//   };

//   // Get unique colors from API data for legend
//   const getUniqueColorsFromData = () => {
//     if (!chartData) return [];

//     const allColors = [];

//     // Collect colors from all channels
//     Object.values(chartData).forEach(channelData => {
//       if (Array.isArray(channelData)) {
//         channelData.forEach(item => {
//           if (item.color && !allColors.some(colorItem => colorItem.color === item.color)) {
//             allColors.push({
//               label: item.label,
//               color: item.color
//             });
//           }
//         });
//       }
//     });

//     return allColors;
//   };

//   // Function to retry fetching data
//   const handleRetry = () => {
//     setError(null);
//     setLoading(true);
//     // The useEffect will automatically re-run since loading state changed
//     window.location.reload(); // Simple reload to refetch all data
//   };

//   if (loading) {
//     return (
//       <div>
//         <LoadingSpinner />
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{
//         marginTop: "50px",
//         textAlign: "center",
//         padding: "2rem"
//       }}>
//         <div style={{
//           backgroundColor: "white",
//           padding: "2rem",
//           borderRadius: "8px",
//           border: "1px solid #e0e0e0",
//           boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
//         }}>
//           <h3 style={{ color: "#dc3545", marginBottom: "1rem" }}>
//             Error Loading Campaign Data
//           </h3>
//           <p style={{ color: "#6c757d", marginBottom: "1.5rem" }}>
//             {error}
//           </p>
//           <p style={{ color: "#6c757d", marginBottom: "2rem" }}>
//             Campaign ID: {cid || "Not provided"}
//           </p>
//           <button
//             onClick={handleRetry}
//             style={{
//               padding: "0.5rem 1.5rem",
//               backgroundColor: "#007bff",
//               color: "white",
//               border: "none",
//               borderRadius: "4px",
//               cursor: "pointer"
//             }}
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!cid) {
//     return (
//       <div style={{
//         marginTop: "50px",
//         textAlign: "center",
//         padding: "2rem"
//       }}>
//         <div style={{
//           backgroundColor: "white",
//           padding: "2rem",
//           borderRadius: "8px",
//           border: "1px solid #e0e0e0"
//         }}>
//           <h3 style={{ color: "#dc3545" }}>No Campaign ID Provided</h3>
//           <p>Please check the URL and try again.</p>
//         </div>
//       </div>
//     );
//   }

//   if (!chartData) {
//     return (
//       <div style={{
//         marginTop: "50px",
//         textAlign: "center",
//         padding: "2rem"
//       }}>
//         <div style={{
//           backgroundColor: "white",
//           padding: "2rem",
//           borderRadius: "8px",
//           border: "1px solid #e0e0e0"
//         }}>
//           <h3 style={{ color: "#ffc107" }}>No Data Available</h3>
//           <p>No campaign data found for Campaign ID: {cid}</p>
//           <button
//             onClick={handleRetry}
//             style={{
//               padding: "0.5rem 1.5rem",
//               backgroundColor: "#007bff",
//               color: "white",
//               border: "none",
//               borderRadius: "4px",
//               cursor: "pointer",
//               marginTop: "1rem"
//             }}
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const uniqueColors = getUniqueColorsFromData();

//   return (
//     <div style={{ marginTop: "50px" }}>
//       {/* Campaign ID Display */}

//       {/* Charts Grid */}
//       {/* <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "1fr 1fr",
//           gridTemplateRows: "1fr 1fr",
//           gap: "2rem",
//           height: "600px",
//         }}
//       > */}
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap", // Allow charts to wrap if screen is small
//           gap: "1.5rem",
//           justifyContent: "space-between",
//         }}
//       >
//         {/* Email Chart */}
//         <div style={{ ...chartCardStyle, flex: "1 1 22%", minWidth: "250px" }}>
//           <h4 style={{ ...chartTitleStyle, color: defaultColors.Email }}>Email</h4>
//           <div style={{ flex: 1, position: "relative", height: "250px" }}>
//             <Pie
//               data={createChartConfig("Email", chartData.email || [])}
//               options={{
//                 ...chartOptions,
//               }}
//             />
//           </div>
//         </div>

//         {/* Push Notification Chart */}
//         <div style={{ ...chartCardStyle, flex: "1 1 22%", minWidth: "250px" }}>
//           <h4 style={{ ...chartTitleStyle, color: defaultColors.PushNotification }}>
//             Push Notification
//           </h4>
//           <div style={{ flex: 1, position: "relative", height: "250px" }}>
//             <Pie
//               data={createChartConfig("PushNotification", chartData.push || [])}
//               options={{
//                 ...chartOptions,
//               }}
//             />
//           </div>
//         </div>
//         {/* WhatsApp Chart */}
//         <div style={{ ...chartCardStyle, flex: "1 1 22%", minWidth: "250px" }}>
//           <h4 style={{ ...chartTitleStyle, color: defaultColors.WhatsApp }}>WhatsApp</h4>
//           <div style={{ flex: 1, position: "relative", height: "250px" }}>
//             <Pie
//               data={createChartConfig("WhatsApp", chartData.whatsapp || [])}
//               options={{
//                 ...chartOptions,
//               }}
//             />
//           </div>
//         </div>

//         {/* SMS Chart */}
//         <div style={{ ...chartCardStyle, flex: "1 1 22%", minWidth: "250px" }}>
//           <h4 style={{ ...chartTitleStyle, color: defaultColors.SMS }}>SMS</h4>
//           <div style={{ flex: 1, position: "relative", height: "250px" }}>
//             <Pie
//               data={createChartConfig("SMS", chartData.sms || [])}
//               options={{
//                 ...chartOptions,
//               }}
//             />
//           </div>
//         </div>
//       </div>

//       {/* Color Legend from API Data */}
//       {/* {uniqueColors.length > 0 && (
//         <div
//           style={{
//             marginTop: "2rem",
//             padding: "1.5rem",
//             backgroundColor: "white",
//             borderRadius: "8px",
//             border: "1px solid #e0e0e0",
//           }}
//         >
//           <h4
//             style={{
//               color: "#293241",
//               marginBottom: "1rem",
//               textAlign: "center",
//               fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//             }}
//           >
//             Status Color Mapping
//           </h4>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//               gap: "1rem",
//             }}
//           >
//             {uniqueColors.map((item, index) => (
//               <div
//                 key={index}
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "20px",
//                     height: "20px",
//                     backgroundColor: item.color,
//                     marginRight: "10px",
//                     borderRadius: "4px",
//                     border: "1px solid #ddd",
//                   }}
//                 ></div>
//                 <span
//                   style={{
//                     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//                     fontWeight: "500",
//                   }}
//                 >
//                   {item.label}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       )} */}

//       {/* Channel Selector */}
//       {/* <div
//         className="panel panel-default with-rounded-corner with-shadow mb-3 mt-3"
//         style={{
//           backgroundColor: "#fff",
//           borderRadius: "8px",
//           padding: "15px",
//           marginBottom: "20px",
//           border: "1px solid #e0e0e0",
//         }}
//       >
//       </div> */}

//       {/* Table Section */}
//       <div
//         className="panel panel-default with-rounded-corner with-shadow mt-4"
//         style={{
//           backgroundColor: "white",
//           padding: "1.5rem",
//           borderRadius: "8px",
//           border: "1px solid #e0e0e0",
//           marginTop: "2rem",
//         }}
//       >
//         {/* <div className="panel panel-default with-rounded-corner with-shadow mb-3">
//           <div className="panel-body"> */}
//         <div className="row">
//           <div className="col-md-12">
//             <div className="btn-group" role="group">
//               {Object.keys(defaultColors).map((ch) => (
//                 <button
//                   key={ch}
//                   type="button"
//                   className={`btn ${channel === ch ? "btn-primary" : "btn-default"}`}
//                   onClick={() => handleChannelChange(ch)}
//                 >
//                   {ch}
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>
//         {/* </div>
//         </div> */}
//         <h4
//           style={{
//             color: "#293241",
//             marginBottom: "1rem",
//             fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//           }}
//           className="mt-3"
//         >
//           {channel} Campaign Table Data
//           {tableLoading && <LoadingSpinner />}
//         </h4>

//         <div className="table-responsive">
//           <table className="table table-condensed table-bordered bg-white">
//             <thead>
//               <tr>
//                 <th>Recipient</th>
//                 <th>Status</th>
//                 <th>Created On</th>
//                 <th>Message</th>
//                 <th>Message ID</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tableLoading ? (
//                 <tr>
//                   <td colSpan="5" className="text-center">
//                     <LoadingSpinner />
//                     <div>Loading table data...</div>
//                   </td>
//                 </tr>
//               ) : tableData && tableData.length > 0 ? (
//                 tableData.map((item, index) => (
//                   <tr key={index}>
//                     <td>{item.recipient || "N/A"}</td>
//                     <td>{item.status || "N/A"}</td>
//                     <td>{item.created_on || "N/A"}</td>
//                     <td>{item.message || "N/A"}</td>
//                     <td>{item.messageid || "N/A"}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" className="text-center">
//                     No records found for {channel}.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Reusable styles
// const chartCardStyle = {
//   backgroundColor: "white",
//   borderRadius: "8px",
//   padding: "1rem",
//   boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//   display: "flex",
//   flexDirection: "column",
//   border: "1px solid #e0e0e0",
// };

// const chartTitleStyle = {
//   textAlign: "center",
//   marginBottom: "1rem",
//   fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//   fontWeight: "600",
// };

// export default CampingDetails;




import React, { useEffect, useState } from "react";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { API_URL } from "../../config";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useParams } from "react-router-dom";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, Title);

// Default colors as fallback
const defaultColors = {
  Email: "#007BFF",
  PushNotification: "#FF6B6B",
  WhatsApp: "#22C55E",
  SMS: "#F59E0B",
};

// Chart options
const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        font: {
          size: 12,
          family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        },
        color: "#3D5A80",
        padding: 10,
        usePointStyle: true,
        pointStyle: "circle",
      },
    },
    title: {
      display: true,
      font: {
        size: 16,
        weight: "bold",
        family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      },
      color: "#293241",
      padding: 10,
    },
    tooltip: {
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      titleColor: "#293241",
      bodyColor: "#3D5A80",
      borderColor: "#E94F37",
      borderWidth: 1,
      cornerRadius: 6,
      titleFont: { size: 12, weight: "bold" },
      bodyFont: { size: 11 },
      padding: 8,
    },
  },
  animation: {
    animateScale: true,
    animateRotate: true,
  },
  maintainAspectRatio: false,
};

// Helper function to check if data has non-zero values
const hasNonZeroData = (data) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return false;
  }
  
  return data.some(item => item.value > 0);
};

// Helper function to create chart config using API colors
const createChartConfig = (channel, data) => {
  if (!data || !Array.isArray(data) || data.length === 0 || !hasNonZeroData(data)) {
    return {
      labels: ['No Data'],
      datasets: [
        {
          label: `${channel} Distribution`,
          data: [1],
          backgroundColor: ['#CCCCCC'],
          borderColor: ["#fff"],
          borderWidth: 2,
          hoverBorderColor: "#000",
          hoverBorderWidth: 2,
        },
      ],
    };
  }

  return {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: `${channel} Distribution`,
        data: data.map((item) => item.value),
        backgroundColor: data.map((item) => item.color || defaultColors[channel] || '#CCCCCC'),
        borderColor: ["#fff"],
        borderWidth: 2,
        hoverBorderColor: "#000",
        hoverBorderWidth: 2,
      },
    ],
  };
};

const CampingDetails = () => {
  const { cid } = useParams(); // Get cid from URL
  const [chartData, setChartData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [channel, setChannel] = useState("Email"); // Default channel
  const [error, setError] = useState(null);

  // Fetch chart data
  useEffect(() => {
    const fetchChartData = async () => {
      if (!cid) {
        setError("No Campaign ID provided");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const token = localStorage.getItem("authToken");

        if (!token) {
          setError("Authentication token not found");
          setLoading(false);
          return;
        }

        console.log("Fetching chart data for CID:", cid);

        const response = await axios.get(
          `${API_URL}settings/templateBulkCampaign/chart?cid=${cid}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              accept: "*/*",
            },
            timeout: 30000, // 30 second timeout
          }
        );

        console.log("API Response:", response.data);

        if (response.data && response.data.status && response.data.data) {
          setChartData(response.data.data);
        } else {
          console.error("Invalid API response structure", response.data);
          setError("Invalid data format received from server");
        }
      } catch (error) {
        console.error("Error fetching chart data:", error);
        let errorMessage = "Failed to fetch chart data";

        if (error.response) {
          // Server responded with error status
          errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
        } else if (error.request) {
          // Request made but no response received
          errorMessage = "No response from server. Please check your connection.";
        } else {
          // Something else happened
          errorMessage = error.message;
        }

        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, [cid]);

  // Fetch table data based on selected channel
  const fetchTableData = async (selectedChannel) => {
    if (!cid) {
      console.error("No cid available");
      setTableData([]);
      return;
    }

    setTableLoading(true);
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        console.error("No authentication token");
        setTableData([]);
        return;
      }

      // Map channel names to API endpoints
      const channelEndpoints = {
        Email: "email",
        SMS: "sms",
        PushNotification: "push",
        WhatsApp: "whatsapp"
      };

      const endpoint = channelEndpoints[selectedChannel];

      if (!endpoint) {
        console.error("Invalid channel selected");
        setTableData([]);
        return;
      }

      console.log(`Fetching table data for ${selectedChannel} with CID: ${cid}`);

      const response = await axios.get(
        `${API_URL}settings/templateBulkCampaign/${endpoint}?cid=${cid}&orderBy=created_on&limit=100&offset=0`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            accept: "*/*",
          },
          timeout: 30000,
        }
      );

      console.log(`Table data for ${selectedChannel}:`, response.data);

      if (response.data && response.data.status && Array.isArray(response.data.data)) {
        setTableData(response.data.data);
      } else {
        console.error("Invalid table data response structure");
        setTableData([]);
      }
    } catch (error) {
      console.error(`Error fetching ${channel} table data:`, error);
      setTableData([]);
    } finally {
      setTableLoading(false);
    }
  };

  // Fetch table data when channel changes
  useEffect(() => {
    if (cid && chartData) { // Only fetch table data if chart data is loaded
      fetchTableData(channel);
    }
  }, [channel, cid, chartData]); // Added chartData as dependency

  // Get unique colors from API data for legend
  const getUniqueColorsFromData = () => {
    if (!chartData) return [];

    const allColors = [];

    // Collect colors from all channels
    Object.values(chartData).forEach(channelData => {
      if (Array.isArray(channelData)) {
        channelData.forEach(item => {
          if (item.color && !allColors.some(colorItem => colorItem.color === item.color)) {
            allColors.push({
              label: item.label,
              color: item.color
            });
          }
        });
      }
    });

    return allColors;
  };

  // Function to check if a channel has data to display
  const shouldDisplayChart = (channelData) => {
    return channelData && Array.isArray(channelData) && hasNonZeroData(channelData);
  };

  // Get available channels with data
  const getAvailableChannels = () => {
    if (!chartData) return [];

    const channels = [];
    
    if (shouldDisplayChart(chartData.email)) channels.push("Email");
    if (shouldDisplayChart(chartData.push)) channels.push("PushNotification");
    if (shouldDisplayChart(chartData.whatsapp)) channels.push("WhatsApp");
    if (shouldDisplayChart(chartData.sms)) channels.push("SMS");
    
    return channels;
  };

  // Update channel if current channel is not available - MOVED THIS BEFORE CONDITIONAL RETURNS
  const availableChannels = getAvailableChannels();
  useEffect(() => {
    if (availableChannels.length > 0 && !availableChannels.includes(channel)) {
      setChannel(availableChannels[0]);
    }
  }, [availableChannels, channel]);

  // Function to retry fetching data
  const handleRetry = () => {
    setError(null);
    setLoading(true);
    // The useEffect will automatically re-run since loading state changed
    window.location.reload(); // Simple reload to refetch all data
  };

  if (loading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        marginTop: "50px",
        textAlign: "center",
        padding: "2rem"
      }}>
        <div style={{
          backgroundColor: "white",
          padding: "2rem",
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
          <h3 style={{ color: "#dc3545", marginBottom: "1rem" }}>
            Error Loading Campaign Data
          </h3>
          <p style={{ color: "#6c757d", marginBottom: "1.5rem" }}>
            {error}
          </p>
          <p style={{ color: "#6c757d", marginBottom: "2rem" }}>
            Campaign ID: {cid || "Not provided"}
          </p>
          <button
            onClick={handleRetry}
            style={{
              padding: "0.5rem 1.5rem",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!cid) {
    return (
      <div style={{
        marginTop: "50px",
        textAlign: "center",
        padding: "2rem"
      }}>
        <div style={{
          backgroundColor: "white",
          padding: "2rem",
          borderRadius: "8px",
          border: "1px solid #e0e0e0"
        }}>
          <h3 style={{ color: "#dc3545" }}>No Campaign ID Provided</h3>
          <p>Please check the URL and try again.</p>
        </div>
      </div>
    );
  }

  if (!chartData) {
    return (
      <div style={{
        marginTop: "50px",
        textAlign: "center",
        padding: "2rem"
      }}>
        <div style={{
          backgroundColor: "white",
          padding: "2rem",
          borderRadius: "8px",
          border: "1px solid #e0e0e0"
        }}>
          <h3 style={{ color: "#ffc107" }}>No Data Available</h3>
          <p>No campaign data found for Campaign ID: {cid}</p>
          <button
            onClick={handleRetry}
            style={{
              padding: "0.5rem 1.5rem",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              marginTop: "1rem"
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  const uniqueColors = getUniqueColorsFromData();

  return (
    <div style={{ marginTop: "50px" }}>
      {/* Charts Grid */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1.5rem",
          justifyContent: availableChannels.length > 2 ? "space-between" : "flex-start",
        }}
      >
        {/* Email Chart - Only display if has data */}
        {shouldDisplayChart(chartData.email) && (
          <div style={{ ...chartCardStyle, flex: "1 1 22%", minWidth: "250px" }}>
            <h4 style={{ ...chartTitleStyle, color: defaultColors.Email }}>Email</h4>
            <div style={{ flex: 1, position: "relative", height: "250px" }}>
              <Pie
                data={createChartConfig("Email", chartData.email)}
                options={{
                  ...chartOptions,
                }}
              />
            </div>
          </div>
        )}

        {/* Push Notification Chart - Only display if has data */}
        {shouldDisplayChart(chartData.push) && (
          <div style={{ ...chartCardStyle, flex: "1 1 22%", minWidth: "250px" }}>
            <h4 style={{ ...chartTitleStyle, color: defaultColors.PushNotification }}>
              Push Notification
            </h4>
            <div style={{ flex: 1, position: "relative", height: "250px" }}>
              <Pie
                data={createChartConfig("PushNotification", chartData.push)}
                options={{
                  ...chartOptions,
                }}
              />
            </div>
          </div>
        )}

        {/* WhatsApp Chart - Only display if has data */}
        {shouldDisplayChart(chartData.whatsapp) && (
          <div style={{ ...chartCardStyle, flex: "1 1 22%", minWidth: "250px" }}>
            <h4 style={{ ...chartTitleStyle, color: defaultColors.WhatsApp }}>WhatsApp</h4>
            <div style={{ flex: 1, position: "relative", height: "250px" }}>
              <Pie
                data={createChartConfig("WhatsApp", chartData.whatsapp)}
                options={{
                  ...chartOptions,
                }}
              />
            </div>
          </div>
        )}

        {/* SMS Chart - Only display if has data */}
        {shouldDisplayChart(chartData.sms) && (
          <div style={{ ...chartCardStyle, flex: "1 1 22%", minWidth: "250px" }}>
            <h4 style={{ ...chartTitleStyle, color: defaultColors.SMS }}>SMS</h4>
            <div style={{ flex: 1, position: "relative", height: "250px" }}>
              <Pie
                data={createChartConfig("SMS", chartData.sms)}
                options={{
                  ...chartOptions,
                }}
              />
            </div>
          </div>
        )}

        {/* Show message if no charts have data */}
        {availableChannels.length === 0 && (
          <div style={{
            ...chartCardStyle, 
            flex: "1 1 100%", 
            textAlign: "center",
            padding: "3rem"
          }}>
            <h4 style={{ color: "#6c757d", marginBottom: "1rem" }}>
              No Chart Data Available
            </h4>
            <p style={{ color: "#6c757d" }}>
              All channels have zero values for this campaign.
            </p>
          </div>
        )}
      </div>

      {/* Table Section - Only show if there are available channels */}
      {availableChannels.length > 0 && (
        <div
          className="panel panel-default with-rounded-corner with-shadow mt-4"
          style={{
            backgroundColor: "white",
            padding: "1.5rem",
            borderRadius: "8px",
            border: "1px solid #e0e0e0",
            marginTop: "2rem",
          }}
        >
          <div className="row">
            <div className="col-md-12">
              <div className="btn-group" role="group">
                {availableChannels.map((ch) => (
                  <button
                    key={ch}
                    type="button"
                    className={`btn ${channel === ch ? "btn-primary" : "btn-default"}`}
                    onClick={() => setChannel(ch)}
                  >
                    {ch}
                  </button>
                ))}
              </div>
            </div>
          </div>
          
          <h4
            style={{
              color: "#293241",
              marginBottom: "1rem",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            }}
            className="mt-3"
          >
            {channel} Campaign Table Data
            {tableLoading && <LoadingSpinner />}
          </h4>

          <div className="table-responsive">
            <table className="table table-condensed table-bordered bg-white">
              <thead>
                <tr>
                  <th>Recipient</th>
                  <th>Status</th>
                  <th>Created On</th>
                  <th>Message</th>
                  <th>Message ID</th>
                </tr>
              </thead>
              <tbody>
                {tableLoading ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      <LoadingSpinner />
                      <div>Loading table data...</div>
                    </td>
                  </tr>
                ) : tableData && tableData.length > 0 ? (
                  tableData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.recipient || "N/A"}</td>
                      <td>{item.status || "N/A"}</td>
                      <td>{item.created_on || "N/A"}</td>
                      <td>{item.message || "N/A"}</td>
                      <td>{item.messageid || "N/A"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No records found for {channel}.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

// Reusable styles
const chartCardStyle = {
  backgroundColor: "white",
  borderRadius: "8px",
  padding: "1rem",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  display: "flex",
  flexDirection: "column",
  border: "1px solid #e0e0e0",
};

const chartTitleStyle = {
  textAlign: "center",
  marginBottom: "1rem",
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  fontWeight: "600",
};

export default CampingDetails;